var map = {
	"./staging_holiday_promo_23d_quiz_default.json": [
		33911,
		3911
	],
	"./staging_holiday_promo_3_quiz_default.json": [
		25263,
		5263
	],
	"./staging_holiday_promo_quiz_default.json": [
		24040,
		4040
	],
	"./staging_new_h_2_quiz_default.json": [
		50328,
		328
	],
	"./staging_new_h_quiz_default.json": [
		25227,
		5227
	],
	"./staging_new_t_quiz_default.json": [
		32568,
		2568
	],
	"./staging_quiz_default.json": [
		75567,
		5567
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65916;
module.exports = webpackAsyncContext;